module.exports = __webpack_public_path__ + "img/journal_active.710c2821.svg";